/** The box of an element that useElementSize measures. */
export enum ElementBox {
    /** The content box, as the ResizeObserver reports it. */
    Content = 'content',
    /**
     * The rendered rect (getBoundingClientRect). It has an exact synchronous read, so its first
     * size lands before the first paint.
     */
    Border = 'border',
}
